import React, { useEffect, useState } from "react";
import { Smartphone, Share, PlusSquare, MoreVertical, Download } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { LogoGKPY } from "./LogoGKPY";

let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredPrompt = e; window.dispatchEvent(new Event("siap-install-ready")); });
  window.addEventListener("appinstalled", () => { deferredPrompt = null; localStorage.setItem("siap_gkpy_installed", "1"); window.dispatchEvent(new Event("siap-install-ready")); });
}
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const useInstallApp = () => {
  const [, tick] = useState(0);
  useEffect(() => { const h = () => tick((n) => n + 1); window.addEventListener("siap-install-ready", h); return () => window.removeEventListener("siap-install-ready", h); }, []);
  return { installed: isStandalone(), canPrompt: !!deferredPrompt };
};

export const InstallAppDialog = ({ open, onOpenChange }) => {
  const { canPrompt } = useInstallApp();
  const [hasil, setHasil] = useState(null);
  const pasang = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const r = await deferredPrompt.userChoice; setHasil(r.outcome); if (r.outcome === "accepted") deferredPrompt = null;
  };
  const ios = isIOS();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl max-w-md" data-testid="install-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Smartphone className="h-5 w-5 text-[hsl(224,64%,33%)]" /> Pasang SIAP GKPY di HP</DialogTitle>
          <DialogDescription>Tambahkan ke layar utama agar dapat dibuka seperti aplikasi, tanpa mengetik alamat web saat kunjungan.</DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-3 rounded-xl bg-slate-50 border p-3"><LogoGKPY className="h-12 w-auto" /><div><div className="font-semibold text-slate-900">SIAP GKPY</div><div className="text-xs text-slate-500">Sistem Informasi Administrasi & Pelayanan</div></div></div>
        {hasil === "accepted" ? <div className="text-sm text-emerald-700 font-medium" data-testid="install-sukses">Aplikasi sedang dipasang. Cari ikon SIAP GKPY di layar utama HP Anda.</div>
          : canPrompt ? <Button onClick={pasang} className="w-full min-h-[48px] rounded-xl bg-[hsl(224,64%,33%)] hover:bg-[hsl(224,64%,28%)]" data-testid="install-now-btn"><Download className="h-4 w-4 mr-2" /> Pasang Sekarang</Button>
          : ios ? (
            <ol className="text-sm text-slate-700 space-y-2 list-decimal pl-5" data-testid="install-ios-steps">
              <li>Buka halaman ini di <b>Safari</b>.</li>
              <li>Ketuk tombol <b>Bagikan</b> <Share className="inline h-4 w-4 align-text-bottom" /> di bagian bawah layar.</li>
              <li>Pilih <b>Tambah ke Layar Utama</b> <PlusSquare className="inline h-4 w-4 align-text-bottom" />, lalu ketuk <b>Tambah</b>.</li>
            </ol>
          ) : (
            <ol className="text-sm text-slate-700 space-y-2 list-decimal pl-5" data-testid="install-android-steps">
              <li>Buka halaman ini di <b>Chrome</b> pada HP Android.</li>
              <li>Ketuk menu <MoreVertical className="inline h-4 w-4 align-text-bottom" /> (titik tiga) di pojok kanan atas.</li>
              <li>Pilih <b>Tambahkan ke layar utama</b> / <b>Instal aplikasi</b>, lalu ketuk <b>Tambahkan</b>.</li>
            </ol>
          )}
        <p className="text-xs text-slate-500">Setelah terpasang, SIAP GKPY tetap memerlukan koneksi internet untuk mengakses data.</p>
      </DialogContent>
    </Dialog>
  );
};
